import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {I18nModule, provideDefaultConfig} from '@spartacus/core';
import {ConfiguratorAttributeCompositionConfig} from '@spartacus/product-configurator/rulebased';
import {ComboBoxDropdownModule, ComboBoxModule} from 'ng-design-system';
import {DcpConfiguratorAttributeDropdownComponent} from './dcp-configurator-attribute-dropdown.component';

@NgModule({
  imports: [CommonModule, ComboBoxModule, ComboBoxDropdownModule, I18nModule],
  providers: [
    provideDefaultConfig({
      productConfigurator: {
        assignment: {
          AttributeType_dropdown: DcpConfiguratorAttributeDropdownComponent,
          AttributeType_dropdown_add: DcpConfiguratorAttributeDropdownComponent,
        },
      },
    } as ConfiguratorAttributeCompositionConfig),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [DcpConfiguratorAttributeDropdownComponent],
  exports: [DcpConfiguratorAttributeDropdownComponent],
})
export class DcpConfiguratorAttributeDropDownModule {}
